/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SortDirection = {
    Ascending: 'Ascending',
    Descending: 'Descending',
} as const;
export type SortDirection = typeof SortDirection[keyof typeof SortDirection];

